import { render, staticRenderFns } from "./IdentityStatusRowItem.vue?vue&type=template&id=236f331f&scoped=true&"
import script from "./IdentityStatusRowItem.vue?vue&type=script&lang=js&"
export * from "./IdentityStatusRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f331f",
  null
  
)

export default component.exports